import React from 'react'
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons'
import { Collapse, Tabs } from 'antd'
import { CLAIM_CENTER_NJ_MEDIAL_FAQ, CLAIM_CENTER_MI_MEDIAL_FAQ, CLAIM_CENTER_PA_MEDIAL_FAQ } from '../constants'

import ClaimsStyle from '../../styles/ClaimsCenter.module.css'

const { Panel } = Collapse
const { TabPane } = Tabs

const FAQMedical = () => {
  const executeScroll = key => {
    const element = document.getElementsByClassName(`faq-panel-medical-${key}`)
    if (element && element.length > 0) {
      element[0].scrollIntoView({ behavior: 'smooth' })
    }
  }
  return (
    <Tabs defaultActiveKey="1">
      <TabPane key="1" tab="MICHIGAN">
        <Collapse
          accordion
          className="faq-container-Auto-Damage"
          expandIcon={({ isActive }) => (isActive ? <CaretUpOutlined /> : <CaretDownOutlined />)}
          expandIconPosition="right"
          onChange={key => window.setTimeout(() => executeScroll(key), 500)}
        >
          {CLAIM_CENTER_MI_MEDIAL_FAQ.map((item, index) => (
            <Panel
              key={index}
              className="faq-panel-Auto-Damage faq-panel-medical-0"
              header={item.question}
              style={{ fontSize: '1.2rem' }}
            >
              <div className={`${ClaimsStyle["faq-panel-Auto-Damage-text-content"]}`}>
                <div dangerouslySetInnerHTML={{ __html: item.answer }} style={{ display: 'grid' }} />
              </div>
            </Panel>
          ))}
        </Collapse>
      </TabPane>
      <TabPane key="2" tab="NEW JERSEY">
        <Collapse
          accordion
          className="faq-container-Auto-Damage"
          expandIcon={({ isActive }) => (isActive ? <CaretUpOutlined /> : <CaretDownOutlined />)}
          expandIconPosition="right"
        >
          {CLAIM_CENTER_NJ_MEDIAL_FAQ.map((item, index) => (
            <Panel
              key={index}
              className="faq-panel-Auto-Damage faq-panel-medical-1"
              header={item.question}
              style={{ fontSize: '1.2rem' }}
            >
              <div className={`${ClaimsStyle["faq-panel-Auto-Damage-text-content"]}`}>
                <div dangerouslySetInnerHTML={{ __html: item.answer }} />
              </div>
            </Panel>
          ))}
        </Collapse>
      </TabPane>
      <TabPane key="3" tab="PENNSYLVANIA">
        <Collapse
          accordion
          className="faq-container-Auto-Damage"
          expandIcon={({ isActive }) => (isActive ? <CaretUpOutlined /> : <CaretDownOutlined />)}
          expandIconPosition="right"
        >
          {CLAIM_CENTER_PA_MEDIAL_FAQ.map((item, index) => (
            <Panel
              key={index}
              className="faq-panel-Auto-Damage faq-panel-medical-2"
              header={item.question}
              style={{ fontSize: '1.2rem' }}
            >
              <div className={`${ClaimsStyle["faq-panel-Auto-Damage-text-content"]}`}>
                <div dangerouslySetInnerHTML={{ __html: item.answer }} />
              </div>
            </Panel>
          ))}
        </Collapse>
      </TabPane>
    </Tabs>
  )
}

export default FAQMedical
